import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { LanguageProvider } from './i18n';
import { CustomerProvider } from './contexts/CustomerContext';
import { registerAlertsWorker } from './utils/browserAlerts';
import './index.css';

// Browser notifications: the service worker lets a community alert stay on
// screen after the tab is closed (no-op when the browser has no support).
registerAlertsWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <CustomerProvider>
          <App />
          <Toaster position="top-right" toastOptions={{ style: { borderRadius: '10px', zIndex: 99999 } }} />
        </CustomerProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
